import styled, { css } from 'styled-components'

export const Cell = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    min-width: 0;
    gap: ${theme.space['12']};
  `,
)
